import authInterceptor from "../../AuthInterceptor";

export const RankingAlgorithmSettingsAPI = {
  getRankingWeights: (config = {}) =>
    authInterceptor
      .get(`ranking-api/admin/ranking-weights/`, config)
      .then((response) => response.data)
      .catch((error) => error.response),
  saveRankingWeights: (id, bodyData = {}) =>
    authInterceptor
      .put(`ranking-api/admin/ranking-weights/${id}/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
  restoreDefaultWeights: (id) =>
    authInterceptor
      .post(`ranking-api/admin/ranking-weights/${id}/restore-defaults/`)
      .then((response) => response.data)
      .catch((error) => error.response),
  simulateRanking: (id) =>
    authInterceptor
      .post(`ranking-api/admin/simulate-ranking/${id}/`)
      .then((response) => response.data)
      .catch((error) => error.response),
  reRunRanking: (config = {}) =>
    authInterceptor
      .get(`ranking-api/admin/re-run-ranking/`, config)
      .then((response) => response.data)
      .catch((error) => error.response),
};
